import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { toTimeOfDayText } from './time-of-day.helper';

/** Start and end must differ even while the window is off; the engine refuses such a pair (K-077). */
export function callingWindowTimesValidator(startKey: string, endKey: string): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const start = group.get(startKey)?.value as Date | null;
    const end = group.get(endKey)?.value as Date | null;

    if (!start || !end || toTimeOfDayText(start) !== toTimeOfDayText(end)) {
      return null;
    }

    return { sameCallingWindowTimes: true };
  };
}
